import React, { useEffect, useRef, useState } from "react";
import allProducts from "../Data/allProducts.json";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import Isotope from "isotope-layout";
import imagesLoaded from "imagesloaded";
import CountUp from "react-countup";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";

const slides = [
  {
    image: "/assets/img/h1-slide3.webp",
    heading: (
      <>
        <span style={{ color: "#FFD700" }}>Every Crop</span> Counts,{" "}
        <span style={{ color: "#FFD700" }}>Every Farmer</span> Matters.
      </>
    ),
    description:
      "The paramount doctrine of the economic and technological euphoria of recent decades has been that everything depends on innovation.",
  },
  {
    image: "/assets/img/2.webp",
    heading: (
      <>
        <span style={{ color: "#FFD700" }}>Sustainable</span> Agriculture for a
        Better Future.
      </>
    ),
    description:
      "Modern farming techniques ensure food security and economic stability for millions of farmers worldwide.",
  },
  {
    image: "/assets/img/3.webp",
    heading: (
      <>
        <span style={{ color: "#FFD700" }}>Innovation</span> in Agriculture
        Drives Progress.
      </>
    ),
    description:
      "From smart farming to AI-driven solutions, agriculture is evolving to meet future demands.",
  },
];

const icons = [
  {
    src: "assets/img/aboutus/anniversary.webp",
    alt: "25 Years",
    label: "25+ Years Experience",
  },
  {
    src: "assets/img/aboutus/achievement.webp",
    alt: "Quality",
    label: "Quality in Every Aspect",
  },
  {
    src: "assets/img/aboutus/cogs.webp",
    alt: "Machinery",
    label: "Latest Machinery",
  },
  {
    src: "assets/img/aboutus/experiment.webp",
    alt: "R&D",
    label: "R & D Department",
  },
  {
    src: "assets/img/aboutus/team.webp",
    alt: "Team",
    label: "Qualified Marketing Staff",
  },
];

const Home = () => {
  const isotopeRef = useRef(null);
  const containerRef = useRef(null);
  const [activeFilter, setActiveFilter] = useState(null);
  const [inView, setInView] = useState(false);
  const statsRef = useRef(null);
  const [visibleCounts, setVisibleCounts] = useState({
    fungicide: 30,
    insecticide: 30,
    pgr: 30,
    herbicide: 30,
    fertilizer: 30,
  });

  const handleIntersection = (entries) => {
    const [entry] = entries;
    if (entry.isIntersecting) {
      setInView(true);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(handleIntersection, {
      threshold: 0.5,
    });

    if (statsRef.current) {
      observer.observe(statsRef.current);
    }

    return () => {
      if (statsRef.current) {
        observer.unobserve(statsRef.current);
      }
    };
  }, []);
  const settings = {
    dots: true,
    infinite: true,
    speed: 3000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: true,
  };

  // Init Isotope on mount
  useEffect(() => {
    if (!containerRef.current) return;

    imagesLoaded(containerRef.current, () => {
      isotopeRef.current = new Isotope(containerRef.current, {
        itemSelector: ".isotope-item",
        layoutMode: "masonry",
        filter: "none", // 🔴 hide all products on load
      });
    });

    return () => isotopeRef.current?.destroy();
  }, []);

  const handleFilterClick = (filter) => {
    setActiveFilter(filter);

    if (!isotopeRef.current) return;

    if (filter === "*") {
      //SHOW ALL PRODUCTS
      isotopeRef.current.arrange({ filter: "*" });
    } else {
      //SHOW SELECTED CATEGORY ONLY
      isotopeRef.current.arrange({ filter });
    }
  };

  useEffect(() => {
    const onFilterEvent = (e) => {
      const category = e.detail;
      const filterClass = `.filter-${category.toLowerCase()}`;
      setActiveFilter(filterClass);
      isotopeRef.current?.arrange({ filter: filterClass });
    };

    window.addEventListener("product-filter", onFilterEvent);
    return () => window.removeEventListener("product-filter", onFilterEvent);
  }, []);

  return (
    <main className="main">
      {/* /Hero Section */}
      <section
        className="position-relative vh-100 overflow-hidden slider-view home"
        id="home"
      >
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div key={index} className="slider-slide position-relative vh-100">
              <img
                src={slide.image}
                alt={`Slide ${index + 1}`}
                className="position-absolute top-0 start-0 w-100 h-100"
                style={{ objectFit: "cover", objectPosition: "center" }}
              />
              <div
                className="position-absolute top-0 start-0 w-100 h-100 gradient-overlay"
                style={{ zIndex: 1 }}
              />
              <div
                className="position-absolute top-0 start-0 w-100 h-100 d-flex flex-column justify-content-center align-items-center text-center px-3"
                style={{ zIndex: 2, color: "#fff" }}
              >
                <h2
                  className="display-4 fw-bold Slider-text"
                  data-aos="fade-left"
                  data-aos-delay={500}
                  style={{
                    fontFamily: "'Montserrat', sans-serif",
                    color: "#ffffff",
                  }}
                >
                  {slide.heading}
                </h2>

                <p
                  className="lead mb-2 px-2 px-md-5"
                  data-aos="fade-right"
                  data-aos-delay={300}
                >
                  {slide.description}
                </p>
              </div>
            </div>
          ))}
        </Slider>
      </section>
      {/* Product Slider Section */}
      <section id="latest-products" className="section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Best Selling Products</h2>
          <p>Check out our top picks!</p>
        </div>
        <div
          className="product-slider-container"
          data-aos="fade-up"
          data-aos-delay={100}
        >
          <div className="product-slider">
            {/* Original Products */}
            <div className="product-card">
              <img
                src="assets/img/toppick/fungicide_azotil_2.webp"
                alt="Product 1"
              />
              <h4>AZOTIL</h4>
            </div>
            <div className="product-card">
              <img
                src="assets/img/products/pgr_innocharge_37.webp"
                alt="Product 2"
              />
              <h4>INNOCHARGE</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/drkarishma_.webp" alt="Product 3" />
              <h4>DR KARISHMA</h4>
            </div>
            <div className="product-card">
              <img
                src="assets/img/toppick/fungicide_tebazu_7.webp"
                alt="TEBAZU"
              />
              <h4>TEBAZU</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/tisor_top.webp" alt="Product 1" />
              <h4>TISOR</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/difence_top.webp" alt="Product 1" />
              <h4>DIFENCE</h4>
            </div>
            {/* Duplicate Products for infinite scroll effect */}
            <div className="product-card">
              <img
                src="assets/img/toppick/fungicide_azotil_2.webp"
                alt="Product 1"
              />
              <h4>AZOTIL</h4>
            </div>
            <div className="product-card">
              <img
                src="assets/img/toppick/pgr_innocharge_37.webp"
                alt="Product 2"
              />
              <h4>INNOCHARGE</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/drkarishma_.webp" alt="Product 3" />
              <h4>DR KARISHMA</h4>
            </div>
            <div className="product-card">
              <img
                src="assets/img/toppick/fungicide_tebazu_7.webp"
                alt="TEBAZU"
              />
              <h4>TEBAZU</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/tisor_top.webp" alt="Product 1" />
              <h4>TISOR</h4>
            </div>
            <div className="product-card">
              <img src="assets/img/toppick/difence_top.webp" alt="Product 1" />
              <h4>DIFENCE</h4>
            </div>
          </div>
        </div>
      </section>
      {/* About Section */}
      <section
        id="about"
        className="about section"
        style={{
          backgroundImage: `url('assets/img/aboutus/bg-1.webp'), url('assets/img/aboutus/bg-2.webp')`,
          backgroundRepeat: "no-repeat, no-repeat",
          backgroundPosition: "top left, bottom right",
          backgroundSize: "140px, 140px",
        }}
      >
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>About Us</h2>
          <p>
            About Innovex Crop
            <br />
          </p>
        </div>
        {/* End Section Title */}
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-6">
              <h3 data-aos="fade-up" data-aos-delay={100}>
                Empowering Farmers, Enhancing Agriculture
              </h3>
              <p
                className="justify-text"
                data-aos="fade-up"
                data-aos-delay={300}
                style={{ lineHeight: "1.5" }}
              >
                At Innovex Crop, we are dedicated to revolutionizing Indian
                agriculture with advanced solutions that tackle both biotic and
                abiotic stressors. By addressing the challenges of soil
                degradation, excessive pesticide use, and declining crop health,
                we empower farmers with sustainable and effective farming
                methods. With a strong product of insecticides, fungicides,
                herbicides, plant growth regulators, and essential nutrients, we
                strive to boost productivity, protect crops, and ensure
                long-term sustainability. Join us in cultivating a healthier,
                more prosperous agricultural future.
              </p>
              <p
                data-aos="fade-up"
                data-aos-delay={350}
                style={{ lineHeight: "1.5" }}
              >
                Our products has manufacturing unit located at Ahmedabad in
                gujarat. it runs on world class technologies and quality
                services. Company focused on quality to serve its customers.
                Each stage of production from raw material to finished product
                is closely monitored and maintains the standard. Company's unit
                certified with international standard under process ISO
                9001:2015 for quality.
              </p>
              <div className="content">
                <ul
                  data-aos="fade-up"
                  data-aos-delay={350}
                  style={{ lineHeight: "1.5" }}
                >
                  <h5>Quality Policy</h5>
                  <li>
                    <i className="bi bi-check-circle-fill" />{" "}
                    <span>Total commitment to customer satisfaction.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" />{" "}
                    <span>Environmental protection and advancement.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" />{" "}
                    <span>Market leadership with innovation.</span>
                  </li>
                  <li>
                    <i className="bi bi-check-circle-fill" />{" "}
                    <span> Striving for excellence in every aspect.</span>
                  </li>
                </ul>
              </div>
            </div>
            <div className="col-lg-6" data-aos="fade-up" data-aos-delay={250}>
              <div
                className="content ps-0 ps-lg-5"
                style={{ lineHeight: "1.5" }}
              >
                <p>
                  <b>INNOVEX CROP TECHNOLOGIES</b> is a agriculture input
                  company. Through science and innovation we changing indian
                  farming traditional to Modern Agriculture, we offer amongst
                  the best of farm protection and associated products in india.
                  We help in providing the farmers not just customized products
                  but customized solutions, developing and evaluating product
                  and processes for improving their satisfaction & help to
                  increase farmer's income. We combine economic success with
                  environmental protection and social responsibility.
                </p>
                {/* Mission, Vision, Values */}
                <div className="row gy-4">
                  <div className="pt-2" data-aos="fade-up" data-aos-delay="300">
                    <div className="card shadow">
                      <div className="">
                        <h5 className="card-title">Our Mission</h5>
                        <p className="">
                          Improve life globally by delivering quality
                          agricultural products, boosting yields, and ensuring
                          food security.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pt-2" data-aos="fade-up" data-aos-delay="400">
                    <div className="card shadow h-100">
                      <div className="">
                        <h5 className="card-title">Our Vision</h5>
                        <p className="card-text">
                          Creating results for customers through a wide range of
                          innovative crop protection products while following
                          "Farmer First" principles.
                        </p>
                      </div>
                    </div>
                  </div>
                  <div className="pt-2" data-aos="fade-up" data-aos-delay="500">
                    <div className="card shadow">
                      <div className="">
                        <h5 className="card-title">Our Values</h5>
                        <ul className="list-unstyled">
                          <li>
                            <i className="bi bi-check-circle-fill" />{" "}
                            <span> Integrity and Equality</span>
                          </li>
                          <li>
                            <i className="bi bi-check-circle-fill" />{" "}
                            <span>Collaboration and Innovation</span>
                          </li>
                          <li>
                            <i className="bi bi-check-circle-fill" />{" "}
                            <span>Commitment to Sustainability</span>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="my-2" data-aos="fade-up" data-aos-delay={600}>
          <div className="row text-center justify-content-center g-5">
            {icons.map((item, index) => (
              <div key={index} className="col-6 col-sm-4 col-md-3 col-lg-2">
                <img
                  src={item.src}
                  alt={item.alt}
                  className="img-fluid rounded-4 mb-2 about-icon mx-auto d-block"
                />
                <h6>
                  <strong>{item.label}</strong>
                </h6>
              </div>
            ))}
          </div>
        </div>
      </section>
      {/* Stats Section */}
      <section
        id="stats"
        ref={statsRef}
        className="stats section light-background"
      >
        <div className="container">
          <div className="row gy-4">
            <div className="col-lg-3 col-md-6">
              <div className="stats-item d-flex align-items-center w-100 h-100">
                <i className="bi bi-emoji-smile color-blue flex-shrink-0" />
                <div>
                  <h3>
                    {inView && <CountUp end={500} duration={1.5} suffix="+" />}
                  </h3>
                  <p>Happy Dealers</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="stats-item d-flex align-items-center w-100 h-100">
                <i className="bi bi-box2 color-orange flex-shrink-0" />
                <div>
                  <h3>
                    {inView && <CountUp end={88} duration={1.5} suffix="+" />}
                  </h3>
                  <p>Products</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="stats-item d-flex align-items-center w-100 h-100">
                <i className="bi bi-headset color-green flex-shrink-0" />
                <div>
                  <h3>
                    {inView && <CountUp end={1463} duration={2} suffix="+" />}
                  </h3>
                  <p>Hours Of Support</p>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="stats-item d-flex align-items-center w-100 h-100">
                <i className="bi bi-people color-pink flex-shrink-0" />
                <div>
                  <h3>
                    {inView && <CountUp end={20} duration={1.2} suffix="+" />}
                  </h3>
                  <p>Qualified Staff</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Product Section */}
      <section id="product" className="product section">
        <div className="container section-title pt-5" data-aos="fade-up">
          <h2>Products</h2>
          <p>CHECK OUR Products</p>
        </div>
        <div className="container">
          <div
            className="isotope-layout"
            data-default-filter="*"
            data-layout="masonry"
            data-sort="original-order"
            ref={isotopeRef}
          >
            {/* Filter Buttons */}
            <div className="container">
              <ul
                className="feature-filters d-flex justify-content-center flex-wrap"
                data-aos="fade-up"
                data-aos-delay={100}
              >
                {[
                  { key: "*", label: "All", icon: "bi-grid" },
                  {
                    key: ".filter-insecticide",
                    label: "Insecticides",
                    icon: "bi-bug",
                  },
                  {
                    key: ".filter-fungicide",
                    label: "Fungicides",
                    icon: "bi-shield-check",
                  },
                  {
                    key: ".filter-herbicide",
                    label: "Herbicides",
                    icon: "bi-tree",
                  },
                  { key: ".filter-pgr", label: "PGR", icon: "bi-flower1" },
                  {
                    key: ".filter-fertilizer",
                    label: "Fertilizers",
                    icon: "bi-droplet",
                  },
                ].map((item) => (
                  <li
                    key={item.key}
                    className={`filter-tab ${
                      activeFilter === item.key ? "filter-active" : ""
                    }`}
                    onClick={() => handleFilterClick(item.key)}
                  >
                    <i className={`bi ${item.icon}`} />
                    <span>{item.label}</span>
                  </li>
                ))}
              </ul>
            </div>
            {/* Product Items */}
            <div
              className="row gy-4 isotope-container"
              data-aos="fade-up"
              data-aos-delay={200}
              ref={containerRef}
            >
              {[
                "insecticide",
                "fungicide",
                "herbicide",
                "pgr",
                "fertilizer",
              ].map((cat) => {
                const filtered = allProducts.filter((p) => p.category === cat);
                const visible = filtered.slice(0, visibleCounts[cat]);

                return (
                  <React.Fragment key={cat}>
                    {visible.map((product) => (
                      <div
                        key={product.id}
                        className={`col-lg-4 col-md-6 product-item isotope-item filter-${product.category} hide-all`}
                      >
                        <div className="product-content h-100">
                          <img
                            src={product.img}
                            className="img-fluid"
                            alt={product.name}
                          />
                          <div className="product-info">
                            <h4>{product.name}</h4>
                            <Link
                              to={`/product/${product.name.toLowerCase()}`}
                              className="btn btn-sm enquire-btn"
                            >
                              Enquiry
                            </Link>
                            <p>{product.tech}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                  </React.Fragment>
                );
              })}
            </div>
          </div>
        </div>
      </section>
      {/* FAQs Section */}
      <section
        id="faq"
        className="faq-section py-5"
        style={{ backgroundColor: "#f0f8f5" }}
      >
        <div className="container">
          <div className="row align-items-center">
            {/* Left Image Side */}
            <div className="col-lg-6 mb-4 mb-lg-0 position-relative">
              <div
                style={{
                  position: "relative",
                  width: "100%",
                  paddingBottom: "100%",
                  overflow: "hidden",
                  borderRadius: "10px",
                }}
              >
                <img
                  src="assets/img/faq-bg.gif"
                  alt="FAQ"
                  style={{
                    position: "absolute",
                    top: "0",
                    left: "0",
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    borderRadius: "10px",
                  }}
                />
                <h1
                  style={{
                    position: "absolute",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    fontSize: "180px",
                    fontWeight: "900",
                    backgroundImage:
                      "url('assets/img/Container background.webp')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    WebkitBackgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "white", // fallback
                    textAlign: "center",
                    margin: "0",
                    letterSpacing: "5px",
                    userSelect: "none",
                    WebkitTextStroke: "2px white",
                  }}
                >
                  FAQ
                </h1>
              </div>
            </div>
            <div className="col-lg-6">
              <h2
                className="mb-4"
                style={{ fontWeight: "700", fontSize: "36px" }}
              >
                Growing Smarter with Innovex Crop
              </h2>
              <div className="accordion" id="faqAccordion">
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingOne">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseOne"
                    >
                      How does Innovex Crop improve soil health?
                    </button>
                  </h2>
                  <div
                    id="collapseOne"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      We provide eco-friendly nutrients and plant growth
                      regulators that restore soil fertility and enhance crop
                      productivity.
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingTwo">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseTwo"
                    >
                      Are your products safe for the environment?
                    </button>
                  </h2>
                  <div
                    id="collapseTwo"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Yes! Our solutions are designed to be sustainable,
                      reducing harmful chemical use while protecting crops
                      effectively.
                    </div>
                  </div>
                </div>
                <div className="accordion-item mb-3">
                  <h2 className="accordion-header" id="headingThree">
                    <button
                      className="accordion-button"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseThree"
                    >
                      Why should farmers trust Innovex Crop?
                    </button>
                  </h2>
                  <div
                    id="collapseThree"
                    className="accordion-collapse collapse show"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      With 500+ satisfied clients, we offer proven,
                      research-backed solutions that maximize yield and ensure
                      long-term farm success.
                    </div>
                  </div>
                </div>
                <div className="accordion-item">
                  <h2 className="accordion-header" id="headingFour">
                    <button
                      className="accordion-button collapsed"
                      type="button"
                      data-bs-toggle="collapse"
                      data-bs-target="#collapseFour"
                    >
                      What makes Innovex Crop different from other companies?
                    </button>
                  </h2>
                  <div
                    id="collapseFour"
                    className="accordion-collapse collapse"
                    data-bs-parent="#faqAccordion"
                  >
                    <div className="accordion-body">
                      Innovex combines 25+ years of agricultural expertise,
                      world-class R&D, the latest technology, and a strong
                      commitment to customer satisfaction and environmental
                      responsibility.
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Testimonials Section */}
      <section id="testimonials" className="testimonials section">
        <img
          src="assets/img/bg-testimonials.webp"
          className="testimonials-bg"
          alt=""
        />
        <div className="container" data-aos="fade-up" data-aos-delay={80}>
          <Swiper
            modules={[Autoplay, Pagination]}
            loop={true}
            autoplay={{
              delay: 4000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            speed={800}
            className="init-swiper"
          >
            {/* Testimonial 1 */}
            <SwiperSlide>
              <div className="testimonial-item">
                <img
                  src="assets/img/aboutus/user.webp"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Rajesh Patel</h3>
                <h4>Gujarat</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  <span>
                    Innovex Crop transformed my farming! My yields have
                    increased, and my soil is healthier than ever.
                  </span>
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </SwiperSlide>

            {/* Testimonial 2 */}
            <SwiperSlide>
              <div className="testimonial-item">
                <img
                  src="assets/img/aboutus/user.webp"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Sunita Sharma</h3>
                <h4>Maharashtra</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  <span>
                    Finally, eco-friendly solutions that actually work! My crops
                    are thriving without excessive chemicals.
                  </span>
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </SwiperSlide>

            {/* Testimonial 3 */}
            <SwiperSlide>
              <div className="testimonial-item">
                <img
                  src="assets/img/aboutus/user.webp"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Amit Verma</h3>
                <h4>Punjab</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  <span>
                    Reliable and effective products. Innovex Crop has helped me
                    protect my farm and boost productivity.
                  </span>
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </SwiperSlide>

            {/* Testimonial 4 */}
            <SwiperSlide>
              <div className="testimonial-item">
                <img
                  src="assets/img/aboutus/user.webp"
                  className="testimonial-img"
                  alt=""
                />
                <h3>Kiran Reddy</h3>
                <h4>Karnataka</h4>
                <div className="stars">
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                  <i className="bi bi-star-fill" />
                </div>
                <p>
                  <i className="bi bi-quote quote-icon-left" />
                  <span>
                    Innovex Crop truly cares about farmers. Their innovative
                    solutions have made a real difference for me.
                  </span>
                  <i className="bi bi-quote quote-icon-right" />
                </p>
              </div>
            </SwiperSlide>
          </Swiper>
        </div>
      </section>
      {/* Team Section */}
      <section id="team" className="team section light-background">
        {/* Section Title */}
        <div className="container section-title" data-aos="fade-up">
          <h2>Team</h2>
          <p>CHECK OUR TEAM</p>
        </div>
        {/* End Section Title */}
        <div className="container">
          <div className="row gy-5">
            {/* Team Member 1 */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay={100}
            >
              <div className="member">
                <div className="pic">
                  <img
                    src="assets/img/team/8.webp"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="member-info">
                  <h4>Mr Chintan Zatakiya</h4>
                  <span>CEO and Founder</span>
                </div>
              </div>
            </div>

            {/* Team Member 2 */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay={200}
            >
              <div className="member">
                <div className="pic">
                  <img
                    src="assets/img/team/4.webp"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="member-info">
                  <h4>Mr Nitin Menpara</h4>
                  <span>Managing Director</span>
                </div>
              </div>
            </div>

            {/* Team Member 3 */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay={300}
            >
              <div className="member">
                <div className="pic">
                  <img
                    src="assets/img/team/6.webp"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="member-info">
                  <h4>Mr Dhrumik Makwana</h4>
                  <span>Director</span>
                </div>
              </div>
            </div>

            {/* Team Member 4 */}
            <div
              className="col-lg-3 col-md-6"
              data-aos="fade-up"
              data-aos-delay={400}
            >
              <div className="member">
                <div className="pic">
                  <img
                    src="assets/img/team/2.webp"
                    className="img-fluid"
                    alt=""
                  />
                </div>
                <div className="member-info">
                  <h4>Mr Samir Dadhaniya</h4>
                  <span>Director</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Contact Section */}
      <section id="contact" className="contact section">
        <div className="container section-title" data-aos="fade-up">
          <h2>Contact Us</h2>
        </div>
        <div className="container" data-aos="fade-up" data-aos-delay={100}>
          <div className="row gy-4">
            <div className="col-lg-6">
              <div className="row gy-4">
                <div className="col-lg-12">
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay={200}
                  >
                    <div
                      className="map-wrapper"
                      data-aos="fade-up"
                      data-aos-delay={200}
                    >
                      <iframe
                        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d229.56359615366503!2d72.48840571844731!3d22.986382542443565!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e9aecfc87b927%3A0x33790ac9ce2ae7c3!2sMahalaxmi%20estate%2C%20a-02%2C%20Sanand%20-%20Sarkhej%20Rd%2C%20beside%20Survey%20no.259%2C%20Sarkhej%2C%20Ahmedabad%2C%20Sarkhej-Okaf%2C%20Gujarat%20382210%2C%20India!5e0!3m2!1sen!2sus!4v1746094416049!5m2!1sen!2sus"
                        allowFullScreen=""
                        loading="lazy"
                        referrerPolicy="no-referrer-when-downgrade"
                      ></iframe>
                    </div>

                    {/* End Google Maps */}
                    <h3>Address</h3>
                    <p>Office & Factory</p>
                    <p>
                      Plot No.38, Mahalaxmi Estate, Iyava, Sanad,
                      Ahmedabad-382170, Gujarat(IND)
                    </p>
                  </div>
                </div>
                {/* End Info Item */}
                <div className="col-md-6">
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay={300}
                  >
                    <i className="bi bi-telephone" />
                    <h3>Customer Care</h3>
                    <p>+91 89896 16200</p>
                  </div>
                </div>
                {/* End Info Item */}
                <div className="col-md-6">
                  <div
                    className="info-item d-flex flex-column justify-content-center align-items-center"
                    data-aos="fade-up"
                    data-aos-delay={400}
                  >
                    <i className="bi bi-envelope" />
                    <h3>Email Us</h3>
                    <p>innovexcroptech@gmail.com</p>
                  </div>
                </div>
                {/* End Info Item */}
              </div>
            </div>
            <div className="col-lg-6">
              <form
                action="https://formspree.io/f/xnndjkrz"
                method="POST"
                className="php-email-form"
              >
                <div className="row gy-4">
                  <div className="col-md-6">
                    <input
                      type="text"
                      name="user_name"
                      className="form-control"
                      placeholder="Your Name"
                      required
                    />
                  </div>
                  <div className="col-md-6">
                    <input
                      type="email"
                      name="user_email"
                      className="form-control"
                      placeholder="Your Email"
                      required
                    />
                  </div>
                  <div className="col-md-12">
                    <input
                      type="text"
                      name="subject"
                      className="form-control"
                      placeholder="Subject"
                      required
                    />
                  </div>
                  <div className="col-md-12">
                    <textarea
                      name="message"
                      rows="12"
                      className="form-control"
                      placeholder="Message"
                      required
                    />
                  </div>
                  <div className="col-md-12 text-center">
                    <button type="submit" className="btn btn-primary">
                      Send Message
                    </button>
                  </div>
                </div>
              </form>
            </div>
            {/* End Contact Form */}
          </div>
        </div>
      </section>
    </main>
  );
};

export default Home;
